import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {DatatableDataModule} from "../../../../../../core/component/datatable-data/datatable-data.module";
import {PriceLabelModule} from "../../../../../../common/price/api/component/price-label/price-label.module";
import {SaleProductCardRowComponent} from "./sale-product-card-row.component";
import {ActionButtonModule} from "../../../../../../core/component/action-button/action-button.module";
import {ButtonModule} from "../../../../../../core/component/button/button.module";
import {
    SaleProductUpdatePriceDialogComponent
} from "../sale-product-update-price-dialog/sale-product-update-price-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        DatatableDataModule,
        PriceLabelModule,
        ActionButtonModule,
        ButtonModule,
        SaleProductUpdatePriceDialogComponent,
    ],
    declarations: [
        SaleProductCardRowComponent,
    ],
    exports: [
        SaleProductCardRowComponent
    ],
})
export class SaleProductsCardRowModule {
}
